import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link, useNavigate  } from 'react-router-dom';

const AdminNavbar = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const mdScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleLogout = () => {
    localStorage.clear();
    navigate("/admin/signin");
  };
  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#ffffff",
        boxShadow: "0px 2px 3px -1px rgb(84 77 160 / 20%)",
        padding: 0,
        zIndex: 5,
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "left",
          paddingLeft: 2.5,
          paddingRight: 2.5,
          minHeight: "50px !important",
        }}
      >
        <Link to="/admin/registrations">
          <Box textAlign={"left"} display="flex" alignItems={"center"}>
            <img
              src="/MEF_Logo_PDC_01_small.jpg"
              alt="logo"
              width={mdScreen ? 45 : 40}
              height={mdScreen ? 20 : 20}
            />
            <Typography
              variant="caption"
              noWrap
              ml={1}
              mt={0.5}
              sx={{
                display: { xs: "none", md: "flex" },
                color: "primary.main",
                textDecoration: "none",
                lineHeight: "1.25em",
                fontWeight: 600,
              }}
            >
              Identify & Quantify <br /> Macro-Energy-Esg Risk
            </Typography>
          </Box>
        </Link>

        {localStorage.getItem("admintoken") ? (
          <Box display={"flex"} alignItems={"center"}>
            <LogoutIcon color="primary" fontSize="small" />
            <Button
              onClick={handleLogout}
              size="small"
              sx={{
                marginLeft: 1,
              }}
            >
              Logout
            </Button>
          </Box>
        ) : null}
      </Toolbar>
    </AppBar>
  );
};
export default AdminNavbar;
